var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RadioGroup',{attrs:{"stacked":true,"options":[
        { text: 'Faturado', value: 2 },
        { text: 'Não Faturado', value: 1 },
        { text: 'Não Fatura (Cancelado)', value: 3 } ]},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}}),_c('div',{staticClass:"text-center"},[_c('Button',{attrs:{"_key":"btnUpdate","title":"Aplicar","backGroundColor":"#02D1C1","color":"white","size":"medium","clicked":_vm.update}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }